import moment from 'moment';
export const defaultDate =() => {
    const nowQuarter = moment().quarter();
    let beginDateDefault = moment().format('YYYY-MM');
    let endDateDefault = moment().format('YYYY-MM');
    if(nowQuarter=="1"){
        beginDateDefault=moment(`${moment().format('YYYY')}-01`).format('YYYY-MM');
        endDateDefault=moment(`${moment().format('YYYY')}-03`).format('YYYY-MM');
    }
    if(nowQuarter=="2"){
        beginDateDefault=moment(`${moment().format('YYYY')}-04`).format('YYYY-MM');
        endDateDefault=moment(`${moment().format('YYYY')}-06`).format('YYYY-MM');
    }
    if(nowQuarter=="3"){
        beginDateDefault=moment(`${moment().format('YYYY')}-07`).format('YYYY-MM');
        endDateDefault=moment(`${moment().format('YYYY')}-09`).format('YYYY-MM');
    }
    if(nowQuarter=="4"){
        beginDateDefault=moment(`${moment().format('YYYY')}-10`).format('YYYY-MM');
        endDateDefault=moment(`${moment().format('YYYY')}-12`).format('YYYY-MM');
    }
    const defaultDateObj={beginDateDefault,endDateDefault};
    return defaultDateObj;
  }


// WEBPACK FOOTER //
// ./src/common/jsLibs.js